export default "__VITE_ASSET__7ac52021__"